<template>
  <div class="container">
    <h1 class="title">Hallo {{ userName }}</h1>
    <h2 class="subtitle">
      Inhalte verwalten
    </h2>

    <div class="columns">
      <div class="column">
        <div class="box">
          <h3 class="is-size-4">Header-Navigation</h3>
          <b-field label="" class="has-addons">
            <b-select v-model="currentPageTop" expanded>
              <option
                v-for="(option, index) in filteredTop"
                :value="option"
                :key="index"
              >
                {{ option }}
              </option>
            </b-select>
            <div class="control">
              <b-button @click="addToTop" type="is-dark"> Hinzufügen</b-button>
            </div>
          </b-field>

          <b-notification
            aria-close-label="Close notification"
            :closable="false"
            v-if="this.menu.top == 0"
          >
            <p class="has-text-centered">
              <b-icon icon="info-circle" size="is-large"> </b-icon><br />
              Ein Navigations-Element vorhanden!
            </p>
          </b-notification>

          <!-- <div v-for="(item, index) in this.menu.top" :key="index">
            <div class="block">
              <b-button @click="move(menu.top, 'up', index)"
                >Vorreihen</b-button
              >
              <b-button @click="move(menu.top, 'down', index)"
                >Zurückreihen</b-button
              >
              <span class="tag is-success">
                {{ item }}
                <span v-for="(page, i) in pagesByName(item)" :key="i">
                  ({{ page.title }} / {{ page.locale }})
                </span>
                <button
                  class="delete is-small"
                  @click="removeFromTop(index)"
                ></button>
              </span>
            </div>
          </div> -->

          <draggable
            v-model="menu.top"
            class="u-mb2 u-mt2 has-background-grey-lighter u-p1"
            v-if="this.menu.top != 0"
          >
            <transition-group>
              <div class="box" v-for="(item, index) in menu.top" :key="item">
                <div class="columns is-mobile is-vcentered ">
                  <div class="column is-size-5 is-1">{{ index + 1 }}</div>
                  <div
                    class="column has-text-weight-bold is-7-mobile is-8-tablet"
                  >
                    {{ item }}

                    <p
                      class="has-text-grey-dark has-text-weight-normal is-size-7"
                      v-for="(page, i) in pagesByName(item)"
                      :key="i"
                    >
                      <strong>[{{ page.locale }}]</strong> {{ page.title }}
                    </p>
                  </div>
                  <div class="column is-4-mobile is-3-tablet has-text-right">
                    <b-button
                      type="is-danger"
                      @click="removeFromTop(index)"
                      icon-left="trash"
                      class="has-text-right"
                    ></b-button>
                  </div>
                </div>

                <!-- 
                <div class="block">
                   <b-button @click="move(menu.footer, 'up', index)"
                    >Vorreihen</b-button
                  >
                  <b-button @click="move(menu.footer, 'down', index)"
                    >Zurückreihen</b-button
                  >
                  <span class="tag is-success">
                    {{ item }}
                    <span v-for="(page, i) in pagesByName(item)" :key="i">
                      ({{ page.title }} / {{ page.locale }})
                    </span>
                  </span>
                </div> -->
              </div>
            </transition-group>
          </draggable>

          <b-button @click="saveTop" type="is-success" expanded
            >Speichern</b-button
          >
        </div>
      </div>
      <div class="column">
        <div class="box">
          <h3 class="is-size-4">Footer-Navigation</h3>
          <b-field label="" class="has-addons">
            <b-select v-model="currentPageBottom" expanded>
              <option
                v-for="(option, index) in filteredFooter"
                :value="option"
                :key="index"
              >
                {{ option }}
              </option>
            </b-select>
            <div class="control">
              <b-button @click="addToFooter" type="is-dark"
                >Hinzufügen</b-button
              >
            </div>
          </b-field>

          <b-notification
            aria-close-label="Close notification"
            :closable="false"
            v-if="this.menu.footer == 0"
          >
            <p class="has-text-centered">
              <b-icon icon="info-circle" size="is-large"> </b-icon><br />
              Ein Footer Navigations-Element vorhanden!
            </p>
          </b-notification>

          <draggable
            v-model="menu.footer"
            v-if="this.menu.footer != 0"
            class="u-mb2 u-mt2 has-background-grey-lighter u-p1"
          >
            <transition-group>
              <div class="box" v-for="(item, index) in menu.footer" :key="item">
                <div class="columns is-mobile is-vcentered ">
                  <div class="column is-size-5 is-1">{{ index + 1 }}</div>
                  <div
                    class="column has-text-weight-bold is-7-mobile is-8-tablet"
                  >
                    {{ item }}

                    <p
                      class="has-text-grey-dark has-text-weight-normal is-size-7"
                      v-for="(page, i) in pagesByName(item)"
                      :key="i"
                    >
                      <strong>[{{ page.locale }}]</strong> {{ page.title }}
                    </p>
                  </div>
                  <div class="column is-4-mobile is-3-tablet has-text-right">
                    <b-button
                      type="is-danger"
                      @click="removeFromFooter(index)"
                      icon-left="trash"
                      class="has-text-right"
                    ></b-button>
                  </div>
                </div>

                <!-- 
                <div class="block">
                   <b-button @click="move(menu.footer, 'up', index)"
                    >Vorreihen</b-button
                  >
                  <b-button @click="move(menu.footer, 'down', index)"
                    >Zurückreihen</b-button
                  >
                  <span class="tag is-success">
                    {{ item }}
                    <span v-for="(page, i) in pagesByName(item)" :key="i">
                      ({{ page.title }} / {{ page.locale }})
                    </span>
                  </span>
                </div> -->
              </div>
            </transition-group>
          </draggable>

          <b-button @click="saveFooter" type="is-success" expanded
            >Speichern</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import cmsApi from '@/api/cms-api'
import draggable from 'vuedraggable'

export default {
  name: 'SiteMenu',
  components: {
    draggable,
  },
  computed: {
    ...mapGetters({
      userName: 'userName',
    }),
    filteredTop() {
      return this.pageNames.filter(f => !this.menu.top.includes(f))
    },
    filteredFooter() {
      return this.pageNames.filter(f => !this.menu.footer.includes(f))
    },
  },
  data() {
    return {
      menu: {
        top: [],
        footer: [],
      },
      pages: [],
      pageNames: [],
      currentPageTop: '',
      currentPageBottom: '',
    }
  },
  methods: {
    move(a, direction, index) {
      if (a.length > 1) {
        if (direction == 'up') {
          if (index > 0) {
            let tmp = a.splice(index, 1)
            a.splice(index - 1, 0, tmp[0])
          }
        } else {
          if (index < a.length - 1) {
            let tmp = a.splice(index, 1)
            a.splice(index + 1, 0, tmp[0])
          }
        }
      }
    },
    pagesByName(name) {
      return this.pages.filter(f => f.name == name)
    },
    addToTop() {
      if (this.currentPageTop && this.currentPageTop.length > 0) {
        this.menu.top.push(this.currentPageTop)
      }
    },
    addToFooter() {
      if (this.currentPageBottom && this.currentPageBottom.length > 0) {
        this.menu.footer.push(this.currentPageBottom)
      }
    },
    removeFromFooter(index) {
      this.menu.footer.splice(index, 1)
    },
    removeFromTop(index) {
      this.menu.top.splice(index, 1)
    },
    async saveFooter() {
      try {
        await cmsApi.saveFooter(this.menu.footer)
        this.$buefy.toast.open({
          message: `Erfolgreich gespeichert.`,
          type: 'is-success',
        })
      } catch {
        this.$buefy.toast.open({
          message: `Es ist ein Fehler aufgetreten, bitte prüfen Sie Ihre Eingaben und versuchen es erneut.`,
          type: 'is-danger',
        })
      }
    },
    async saveTop() {
      try {
        await cmsApi.saveTop(this.menu.top)
        this.$buefy.toast.open({
          message: `Erfolgreich gespeichert.`,
          type: 'is-success',
        })
      } catch {
        this.$buefy.toast.open({
          message: `Es ist ein Fehler aufgetreten, bitte prüfen Sie Ihre Eingaben und versuchen es erneut.`,
          type: 'is-danger',
        })
      }
    },
  },
  async mounted() {
    this.menu.top = await cmsApi.getTopExtensionPoint()
    this.menu.footer = await cmsApi.getFooterExtensionPoint()
    this.pages = await cmsApi.getPages()
    this.pageNames = [...new Set(this.pages.map(m => m.name))]
  },
}
</script>
